import { Link } from 'react-router-dom';
import type { RecentChangesProps } from '../types';

export function RecentChanges({ changes }: RecentChangesProps) {
  if (changes.length === 0) {
    return null;
  }

  return (
    <div className="mb-8 rounded-lg border border-docs-200 bg-docs-50 p-4 dark:border-docs-800 dark:bg-docs-950">
      <h2 className="mb-3 flex items-center gap-2 text-lg font-semibold text-docs-700 dark:text-docs-300">
        <svg
          className="h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        Recent changes
      </h2>
      <ul className="space-y-2">
        {changes.map((change) => (
          <li key={change.file} className="flex items-center gap-2">
            <span
              className={`inline-flex h-5 w-5 items-center justify-center rounded text-xs font-medium ${
                change.type === 'added'
                  ? 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300'
                  : 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300'
              }`}
            >
              {change.type === 'added' ? '+' : '~'}
            </span>
            <Link
              to={change.path}
              className="text-docs-600 hover:underline dark:text-docs-400"
            >
              {change.title}
            </Link>
            <span className="text-sm text-gray-500 dark:text-gray-400">
              {change.date}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
